export const skylineStoryData = {
  "books": [
    {
      "title": "Weather",
      "uuid": "d06e55e0-96df-11ef-8022-ab3694d28dda",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Numbers",
      "uuid": "e65b9620-9afd-11ef-a27f-1306c9feb84e",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Clothing",
      "uuid": "fb0cfe20-9b01-11ef-a27f-1306c9feb84e",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Food",
      "uuid": "c6af8b10-9d37-11ef-944a-5326657a01f2",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Arts",
      "uuid": "0643b7e0-9d3a-11ef-944a-5326657a01f2",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Sports",
      "uuid": "cba8c190-a453-11ef-943d-77a7e846f8aa",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "At the Zoo",
      "uuid": "b2d50dd0-a454-11ef-925a-81c605fc1330",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Ben Had a Sled",
      "uuid": "04fab5c0-9d3d-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Stop Pop",
      "uuid": "a3db82e0-9d3e-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Ben is on a Trip",
      "uuid": "0b3fe7e0-9d40-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Tom and Dog",
      "uuid": "f342be00-9d40-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Pop at the Pond",
      "uuid": "6e9b7960-9d42-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Diego and the Trunk",
      "uuid": "c2612210-9d43-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Kit and Kat",
      "uuid": "fda65c90-9d44-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Drip Drop",
      "uuid": "d113aec0-9d4f-11ef-a216-5b90e96fe0bf",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Ben and Liz",
      "uuid": "29f74ea0-a1e9-11ef-979d-6deea033f4b8",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Big Ship",
      "uuid": "f3af7ca0-a1ed-11ef-979d-6deea033f4b8",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Moth",
      "uuid": "e1266eb0-a1f0-11ef-979d-6deea033f4b8",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Big Hill",
      "uuid": "c619f710-a1f3-11ef-979d-6deea033f4b8",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Quiz Queen",
      "uuid": "ccb1b930-a1fa-11ef-979d-6deea033f4b8",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Pop and Ben",
      "uuid": "a976bb20-a2ac-11ef-a50f-1108c7b1e687",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "James the Swim Champ",
      "uuid": "9b023510-a3a1-11ef-882f-91bad37104ba",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Beth and the Dogs",
      "uuid": "40f85490-a3b1-11ef-9a4f-69912811ec55",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Black Duck",
      "uuid": "0b6dfb90-b0ae-11ef-8a4a-f770748b9cfa",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Autumn",
      "uuid": "e6dc2cf0-a3b2-11ef-9a4f-69912811ec55",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Pop and the Big Hill",
      "uuid": "88115f70-a3b6-11ef-8a6c-df8df563b706",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Winter",
      "uuid": "641879c0-a3d2-11ef-8a6c-df8df563b706",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Toss That Mess!",
      "uuid": "d4eec720-a3d3-11ef-a9da-074290c20a30",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Spring",
      "uuid": "593f66a0-a3da-11ef-bdee-71b5d8c92fb2",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Chick in the Nest",
      "uuid": "80f415a0-a3db-11ef-8fbc-b9382608ac27",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Summer",
      "uuid": "a7046370-a3dc-11ef-8dea-81b39920a382",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Seed",
      "uuid": "5bf46220-a456-11ef-a84d-07804c31c014",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Sweets",
      "uuid": "e8dcdaf0-a3de-11ef-9b7b-a9166f82dd60",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Wake Up",
      "uuid": "e68539e0-a3df-11ef-adba-872e27874f25",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Be Safe",
      "uuid": "d377a490-a3e0-11ef-adba-872e27874f25",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Hike",
      "uuid": "bfbd3800-a3e2-11ef-adba-872e27874f25",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Fire",
      "uuid": "6614b9c0-a3e4-11ef-96d7-99cb593eb5bb",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Bake a Cake",
      "uuid": "67509fb0-a3e5-11ef-953b-e5962b703e6d",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Safe at the Lake",
      "uuid": "df4325a0-a3e6-11ef-a290-6b6138aa5304",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "A Home for the Fox",
      "uuid": "bc5f4db0-a3e7-11ef-9c20-85b6d0a15f2a",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Drops",
      "uuid": "daca2990-a447-11ef-af9d-5f485f779ddb",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Lunch Bunch",
      "uuid": "0be52830-a449-11ef-91bc-c933e7a570ff",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Water Froze",
      "uuid": "356f0c60-a44a-11ef-88e0-13beb902fba6",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "Time for Bed",
      "uuid": "56674750-a451-11ef-8ac2-8743195a585f",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "We Need Water",
      "uuid": "44c26690-a44e-11ef-8458-033f18b0f3c7",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "The Big Tree",
      "uuid": "f0b80c60-a44f-11ef-b3bb-9d8bb1633860",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "In the Water",
      "uuid": "ef8418e0-a452-11ef-ac59-1b3e6232c4c9",
      "type": "tutor",
      "language": "English",
      "grade": 0
    },
    {
      "title": "I Can Nap",
      "uuid": "c19cd850-a9d3-11ef-849a-e79adf7bdce1",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Pam and Dan Can Help",
      "uuid": "ae6900e0-a9d5-11ef-849a-e79adf7bdce1",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Frog at the Pond",
      "uuid": "a1d63400-a9d6-11ef-a67b-59ad90afef70",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Don the Firefighter",
      "uuid": "a54d3280-a9fb-11ef-9287-bf0c63d25741",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "At the Pond",
      "uuid": "f944e7b0-a9fc-11ef-9287-bf0c63d25741",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "I Wish",
      "uuid": "133e0140-a9ff-11ef-98dc-effc46744ead",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Pam's Pet",
      "uuid": "fc9a9b00-a9ff-11ef-98dc-effc46744ead",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "The Question Book",
      "uuid": "460e0d70-aa01-11ef-baf4-71f91cce6b7c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Ben Went to the Creek",
      "uuid": "6a073b10-aa02-11ef-baf4-71f91cce6b7c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "The Frog is Green",
      "uuid": "a763e3e0-aa03-11ef-8abd-0b7e29544f33",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Pam and Dan Fly Kites",
      "uuid": "53e83b80-aa0d-11ef-b0bc-d120183f603c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Maya the Mole",
      "uuid": "543c9e40-aa27-11ef-ad98-d918ab9b751f",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Jill's Last Day of Class",
      "uuid": "43ace4c0-aa29-11ef-ad98-d918ab9b751f",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Have You Met a Hippo?",
      "uuid": "a37be990-aa2a-11ef-ac96-73b879031efe",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Max Has a Fish",
      "uuid": "943df9e0-aa2b-11ef-b5cf-6707a38df0be",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "How Do Animals Stay Safe",
      "uuid": "0fb99c00-aa2c-11ef-b65a-b16b4aee0fac",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Lem and Tess",
      "uuid": "8cdc47e0-aaaf-11ef-a2bd-7571643a3ef6",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Families Feast",
      "uuid": "a9d69380-aab1-11ef-a2bd-7571643a3ef6",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Meet Sid",
      "uuid": "e2471840-aab4-11ef-ac48-1df9f97f4aa2",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "In the Woods",
      "uuid": "0046bb60-aab6-11ef-ac48-1df9f97f4aa2",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Taj Has Fun",
      "uuid": "2c44d3e0-aab7-11ef-9216-41fde5145f5e",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Family Reunion",
      "uuid": "bb7053e0-aab8-11ef-9216-41fde5145f5e",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Zen Sees Four",
      "uuid": "36232060-aabc-11ef-9216-41fde5145f5e",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Week at the Beach",
      "uuid": "83b060d0-aabd-11ef-81ff-5798b3ea0837",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Join Us!",
      "uuid": "54da6c00-aac3-11ef-84fd-3fe6f2dc3379",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Earth's Spin",
      "uuid": "53b2bf70-aac4-11ef-84fd-3fe6f2dc3379",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Zen Gets a Pet",
      "uuid": "0e64fa80-aac6-11ef-a44e-d9cc7d6278b7",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Dusk to Dawn",
      "uuid": "4fc88590-aac7-11ef-902e-bd76cc830b5c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "In the Fall",
      "uuid": "33516c50-aac8-11ef-8efc-2d22b5b2c1ae",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Wish on a Star",
      "uuid": "066d4eb0-aac9-11ef-be61-bb6f67ee2f2d",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Ciana and Ebony",
      "uuid": "ed257c60-aac9-11ef-afac-e76a57216dfc",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Treat in the Dark",
      "uuid": "c93b30f0-aaca-11ef-9ec1-2fb739d5ee0c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Ciana and Friends Go to the Seashore",
      "uuid": "25d60500-ab49-11ef-8fcd-7dca927995d0",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Amanda and Ben",
      "uuid": "61040e00-ab4a-11ef-8fcd-7dca927995d0",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "The Contest",
      "uuid": "8a65f7d0-ab4b-11ef-ac50-eb525e1475a8",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Puppet in the Attic",
      "uuid": "1b5bb6e0-ab55-11ef-812e-b508c7adb4f4",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Diego Jumped",
      "uuid": "97732e60-ab56-11ef-8e87-07edc5789268",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Lynn and Harry",
      "uuid": "f2661410-ae1f-11ef-97e9-ab7a2543ee3c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Ben Helps",
      "uuid": "3ec36000-ae21-11ef-a252-852ac47e59c4",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Jeff is Moving",
      "uuid": "53ced640-ae22-11ef-9808-2f22474a0c63",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Lynn's Farm",
      "uuid": "aedea550-ae23-11ef-aa0b-b18e2576b279",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Sid and Pam Get Fit",
      "uuid": "4b958d90-ae25-11ef-8c77-f7a6ece5ced0",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Scarf for Max",
      "uuid": "6a9e3c40-ae26-11ef-8718-175ea0141e48",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Off the Couch",
      "uuid": "45f0eef0-ae27-11ef-b0f2-95dbeb9366d2",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Taj on the Stage",
      "uuid": "1a30e980-ae29-11ef-b043-cba8a8136e52",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Kayla Feels Gratitude",
      "uuid": "142a7140-ae2a-11ef-8f1d-bd3a671281f0",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Tess Writes",
      "uuid": "2e9f3ff0-ae2b-11ef-90d2-73be1d24f9d7",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Little by Little",
      "uuid": "e62f7a80-ae2c-11ef-883e-c11aed2e331c",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Dress Up",
      "uuid": "10f227d0-ae65-11ef-b527-abdf3c0008ef",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Lem Gets a Ball",
      "uuid": "8d2b3110-ae66-11ef-9da3-538a43df71aa",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Where They Live",
      "uuid": "96f5cb50-ae67-11ef-97a3-a5a1a26db628",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "It Needs to be Fair",
      "uuid": "0ebfcfc0-ae6b-11ef-97a3-a5a1a26db628",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Sid Likes to Knit",
      "uuid": "0701c0d0-ae8a-11ef-88d4-0f0cf1ee791a",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Ebony's Cat",
      "uuid": "5d3cb270-ae8f-11ef-837e-117ad141dbdf",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "What Beth Likes",
      "uuid": "e611bae0-ae90-11ef-837e-117ad141dbdf",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Kids Can Unite",
      "uuid": "b6798ee0-ae93-11ef-845b-0ba16f0effad",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Jill Likes to Have Fun",
      "uuid": "37c3a0f0-aea1-11ef-845b-0ba16f0effad",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Plans Can Change",
      "uuid": "03f86480-aea2-11ef-845b-0ba16f0effad",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "It's Blue",
      "uuid": "4280bc10-aea3-11ef-9123-f75d8b2f9467",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Everyone is Not the Same",
      "uuid": "04484750-aea4-11ef-8d96-fde344ada418",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "On Pop's Boat",
      "uuid": "5ef24fb0-aea5-11ef-b407-db076f4c31f6",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "A Home on a Boat",
      "uuid": "4d402bb0-aea6-11ef-a85b-a5fcfc9b3315",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "What People Like",
      "uuid": "23dcf770-aea7-11ef-92a3-65a21c99b964",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "I Want to Go Everywhere",
      "uuid": "f6b6c7c0-aea7-11ef-8b00-278f74143f72",
      "type": "tutor",
      "language": "English",
      "grade": 1
    },
    {
      "title": "Jess Helps Meg",
      "uuid": "366e99a0-aee0-11ef-8027-fdc37e89e050",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Best Picnic - Chapter 1",
      "uuid": "3ffcf8c0-aee2-11ef-bbf6-61a6e9ec8406",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Meg and Jeff Play Jazz",
      "uuid": "3874feb0-aee5-11ef-90da-6123847993d2",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Guess the Pet",
      "uuid": "32a46380-aee6-11ef-be19-231fb4396c20",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "How to Trap Mice - Chapter 1",
      "uuid": "785b9140-aee7-11ef-ad5f-913e5f3c6a69",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Kid's Club at Camp - Chapter 1",
      "uuid": "64034190-aeea-11ef-800f-a59da2793647",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Winning the Race - Chapter 1",
      "uuid": "5fdc9060-aeec-11ef-9d0d-71add616f970",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Bug Off! - Chapter 1",
      "uuid": "e15e7c50-aeee-11ef-9636-394e44e5d919",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Camping Trip - Chapter 1",
      "uuid": "597f52e0-af6c-11ef-996e-856f6ee7a45d",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Mice are Nice",
      "uuid": "da7e5dc0-af6f-11ef-b5f7-f30428d4f9f4",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Best Home - Chapter 1",
      "uuid": "69aceb00-af71-11ef-ac22-9f2f015170ab",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Plants Have Powers - Chapter 1",
      "uuid": "36100600-af7c-11ef-940b-59d1020e889c",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Geese and Sheep",
      "uuid": "47c86dc0-af8a-11ef-98bf-370bb6e1ef65",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Drive in the Jeep - Chapter 1",
      "uuid": "934ee1b0-af8b-11ef-a4e3-dd69866601e2",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Trip to the Zoo - Chapter 1",
      "uuid": "0f0fdf50-af8e-11ef-bac1-318bd093d209",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Jill Reads the Book",
      "uuid": "359121f0-af90-11ef-9d3d-fd5f30bcfe02",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Some Fun!",
      "uuid": "d46ce600-af91-11ef-aa9b-8978b9d06419",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Dan Went Fishing - Chapter 1",
      "uuid": "000585f0-af93-11ef-8645-1d60754014a5",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Doghouse",
      "uuid": "7024c2e0-af95-11ef-949d-b72d133abd1e",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Let Jen Play! - Chapter 1",
      "uuid": "e4d08240-af96-11ef-ac7b-1dbe41650677",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Beans at the Market",
      "uuid": "212bd5c0-af9a-11ef-b4ba-4bb28f674a41",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Kayla's Big Accomplishment",
      "uuid": "580551b0-af9b-11ef-b141-6f13bd6ab7c1",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "What Jill Likes",
      "uuid": "b9579b20-af9c-11ef-991a-db40288d5b2b",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Ebony and the Trombone",
      "uuid": "ce5a4ce0-af9f-11ef-a400-e95036126c81",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Playing in the Rain - Chapter 1",
      "uuid": "97cebb20-afa4-11ef-91bf-4d65a71d3824",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Earth's Landforms",
      "uuid": "c26b6780-afa8-11ef-bfd8-155017ff7cb9",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Toad and Goat - Chapter 1",
      "uuid": "015cebb0-afab-11ef-bd98-cd48e9cedf73",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "A Trip to the Plains",
      "uuid": "c0857730-afad-11ef-8f2c-9b6afb3dc43a",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Five Nice Kids - Chapter 1",
      "uuid": "1a0be720-afaf-11ef-845b-7b1bf5bf03cf",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Weather Can Be Wild!",
      "uuid": "434fd6c0-afb2-11ef-86ea-3bcae64dc1e4",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "One Cute Mule",
      "uuid": "8f525880-afb3-11ef-b14a-45ba1e8456bb",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Zen Writes a Paper",
      "uuid": "7801cce0-afb5-11ef-897d-1dc31d047a75",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Amanda and Saul",
      "uuid": "af6048f0-b006-11ef-b673-a31e403613df",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Big Red House - Chapter 1",
      "uuid": "8a2fa560-b008-11ef-9368-17408ec504a6",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Pam Sings",
      "uuid": "20cc49d0-b00c-11ef-a430-dfda0f235be0",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Beth Speaks Up",
      "uuid": "a0dca460-b00e-11ef-9072-cd2627ed8a97",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Lynn Goes to a New Gym - Chapter 1",
      "uuid": "54748630-b011-11ef-9f1e-ad4b47fce32b",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The New Bus Driver - Chapter 1",
      "uuid": "f5eb9920-b013-11ef-8f3c-133d4cab4289",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Night Flight",
      "uuid": "122ddf60-b016-11ef-8eba-4506f502775f",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "You Can Use Your Voice to Create Change - Chapter 1",
      "uuid": "5a1cd4b0-b017-11ef-8bf3-1b8730670600",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Cold Day - Chapter 1",
      "uuid": "43ac3a10-b01f-11ef-b7ae-952fdd1cc133",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Helping the Environment - Chapter 1",
      "uuid": "29964ce0-b021-11ef-bd02-917307509269",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Jill and Mom Outside - Chapter 1",
      "uuid": "2b789a10-b024-11ef-8ba1-79193ffbead2",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Ebony and the Baby - Chapter 1",
      "uuid": "4c832be0-b028-11ef-ad10-efa7da74b732",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Kids Can Help at School - Chapter 1",
      "uuid": "e79d02c0-b025-11ef-a4c0-4176ad4c0b72",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "It Only Takes One - Chapter 1",
      "uuid": "f61c1d00-b029-11ef-ae9e-c5c4878771f6",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Best Friends - Chapter 1",
      "uuid": "f2a0ee10-b02b-11ef-8219-5d3ce7ff07f1",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "We All Can Help - Chapter 1",
      "uuid": "7dd2ab30-b02d-11ef-96d1-05feb0f223d8",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Time to Move - Chapter 1",
      "uuid": "2a8d98a0-b036-11ef-9323-5d3775106436",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Woods - Chapter 1",
      "uuid": "d541c850-b038-11ef-9933-7bd5e5dd76a4",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Tom's Trip - Chapter 1",
      "uuid": "266ef660-b03b-11ef-ac83-35b6ad9300f9",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "On the Island - Chapter 1",
      "uuid": "5ef50980-b03f-11ef-8dd1-0f8d6c8377aa",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "A Family Trip - Chapter 1",
      "uuid": "9e2a9b90-b041-11ef-969d-e3175c4edec4",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Many Moons in the Past - Chapter 1",
      "uuid": "9efea280-b043-11ef-936b-fb373866b035",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "A Vacation at a Hotel - Chapter 1",
      "uuid": "f22074a0-b045-11ef-b5a9-b7344b856d19",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "The Dusty Girl - Chapter 1",
      "uuid": "468bcbd0-b04a-11ef-8291-0d3fe7530436",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Fun Times with Friends - Chapter 1",
      "uuid": "7ebb1e50-b04c-11ef-95f8-23b5a90ddf0f",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Kids Can Do Great Things - Chapter 1",
      "uuid": "7d008b20-b04e-11ef-873b-abc71e3b27e2",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Picking Apples - Chapter 1",
      "uuid": "a1c7e8c0-b050-11ef-8521-5b8286e60ea3",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "I Like to Express Myself - Chapter 1",
      "uuid": "ad956270-b052-11ef-ac79-9f65ae77d3f7",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "My Vacation - Chapter 1",
      "uuid": "8217e440-b054-11ef-a466-0911785abf10",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Doing Neat Things - Chapter 1",
      "uuid": "8f972ca0-b056-11ef-808d-d727adfd1686",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "Grandpa and Grandma - Chapter 1",
      "uuid": "2572dcf0-b058-11ef-aa3b-5b573efd199b",
      "type": "tutor",
      "language": "English",
      "grade": 2
    },
    {
      "title": "People Have Many Talents - Chapter 1",
      "uuid": "c4219d90-b059-11ef-a682-47c50f21a3f6",
      "type": "tutor",
      "language": "English",
      "grade": 2
    }
  ]
}